// extracted by mini-css-extract-plugin
export default {"labelTd":"ThongTinDonvi_labelTd__-Vpvv","tr":"ThongTinDonvi_tr__GJAly"};